<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  image: { type: Object, default: null },
  title: { type: String, required: true },
});
const { t } = useI18n();
const broken = ref(false);
watch(
  () => props.image?.url,
  () => {
    broken.value = false;
  }
);
</script>

<template>
  <div
    class="flex h-16 w-16 shrink-0 items-center justify-center overflow-hidden rounded-lg border border-n-weak bg-n-alpha-2"
  >
    <img
      v-if="image?.url && !broken"
      :src="image.url"
      :alt="image.altText || title"
      class="h-full w-full bg-white object-contain"
      loading="lazy"
      @error="broken = true"
    />
    <span v-else class="px-1 text-center text-xs leading-4 text-n-slate-11">
      {{ t('ORDER_ACTIONS.CATALOG_NO_IMAGE') }}
    </span>
  </div>
</template>
